enum SeasonFilter {
    None = "",
    Christmas = "christmas",
}

export default SeasonFilter;